import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ModalBuilder } from "@redriver/cinnamon";
import BlueAddSvg from "features/../../../shared/assets/blue-add.svg";
import { AddButton } from "features/../../../shared/components/buttons";
import { SheetRoutes } from "constants/routes";
import { getTemplateClients, duplicateSheetFromTemplate } from "./actions";
import { generateSheet } from "../../actions";
import DuplicateFromTemplateModalContent from "./DuplicateFromTemplateModalContent";

const BLANK_SHEET = "blank";

const DuplicateFromTemplateModal = ({
  agreement,
  schedule,
  companyFilters,
  loading,
  triggerState,
}) => {
  const { t } = useTranslation("agreements", {
    keyPrefix: "ScheduleComponents.DuplicateFromTemplate",
  });
  const history = useHistory();

  const dealerOfficeId = companyFilters?.dealerOffice?.id;
  const clientId = agreement?.clientId;
  const scheduleId = schedule?.scheduleId;

  return (
    <ModalBuilder
      withForm
      initialData={{ duplicateOption: BLANK_SHEET }}
      loadAction={getTemplateClients}
      loadParams={dealerOfficeId}
      submitAction={(formValues) => {
        if (formValues.duplicateOption === BLANK_SHEET) {
          return generateSheet({ clientId, dealerOfficeId, scheduleId });
        }
        return duplicateSheetFromTemplate(formValues.templateSheetId, {
          targetClientId: clientId,
          targetScheduleId: scheduleId,
          name: formValues.templateSheetName,
        });
      }}
      onSubmitted={(result) => {
        const sheetId = result?.sheetId ?? result;
        if (sheetId) {
          history.push(SheetRoutes.Sheet(sheetId), { isNewSheet: true });
        }
      }}
      renderTrigger={(showModal) => (
        <div>
          <AddButton
            className="clear-bg"
            content={t("NewSheet")}
            icon={BlueAddSvg}
            onClick={showModal}
            loading={loading || triggerState?.submitting}
          />
        </div>
      )}
      renderModal={(modalProps, formProps, state, templateClients) => (
        <DuplicateFromTemplateModalContent
          modalProps={modalProps}
          formProps={formProps}
          templateClients={
            Array.isArray(templateClients) ? templateClients : []
          }
          dealerOfficeId={dealerOfficeId}
          t={t}
        />
      )}
    />
  );
};

export default DuplicateFromTemplateModal;
